import type { ComputedRef, Ref } from "vue";

type MobileSheetStateOptions = {
  isEnabled?: Ref<boolean> | ComputedRef<boolean>;
};

export const useMobileSheetState = <TKey extends string>(
  keys: readonly TKey[],
  options: MobileSheetStateOptions = {}
) => {
  const isEnabled = options.isEnabled;

  const mobileSheetOpen: Record<TKey, boolean> = reactive(
    Object.fromEntries(keys.map((key) => [key, false])) as Record<TKey, boolean>
  ) as Record<TKey, boolean>;

  const closeAllMobileSheets = () => {
    keys.forEach((key) => {
      mobileSheetOpen[key] = false;
    });
  };

  const openMobileSheet = (key: TKey) => {
    if (isEnabled && !isEnabled.value) return;
    closeAllMobileSheets();
    mobileSheetOpen[key] = true;
  };

  const setMobileSheetVisible = (key: TKey, visible: boolean) => {
    if (!visible) {
      mobileSheetOpen[key] = false;
      return;
    }
    openMobileSheet(key);
  };

  if (isEnabled) {
    watch(isEnabled, (enabled) => {
      if (enabled) return;
      closeAllMobileSheets();
    });
  }

  return {
    mobileSheetOpen,
    openMobileSheet,
    closeAllMobileSheets,
    setMobileSheetVisible,
  };
};
